/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalAlertService {
  constructor(private _translateService: TranslateService) {}

  swalAlert(type: string): Promise<any> {
    return new Promise<any>(resolve => {
      this._translateService.get('message.title').subscribe(() => {
        const titleKey = this.getTitleKey(type);
        const textKey = this.getTextKey(type);
        const confirmButtonText = this.getConfirmButtonText(type);

        Swal.fire({
          title: this._translateService.instant(titleKey),
          text: this._translateService.instant(textKey),
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: this._translateService.instant(
            type === 'cancel' || type === 'address' ? 'No' : 'Cancel'
          ),
          confirmButtonColor: '#f3e00b',
          cancelButtonColor: '#000',
          confirmButtonText: this._translateService.instant(confirmButtonText)
        }).then((result: any) => {
          return resolve(result);
        });
      });
    });
  }

  swalAlertforMinAmount(amount: number): Promise<any> {
    return new Promise<any>(resolve => {
      Swal.fire({
        title: 'Alert',
        text: `Minimum item total should be LYD ${amount.toFixed(2)} to apply coupon`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#000',
        confirmButtonText: 'OK'
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  private getTitleKey(type: string): string {
    switch (type) {
    case 'logout':
    case 'deleteAccount':
    case 'remove':
    case 'cancel':
    case 'address':
      return 'AreYouSure';
    default:
      return 'clearBAG';
    }
  }

  private getTextKey(type: string): string {
    switch (type) {
    case 'logout':
      return 'AreYouSure';
    case 'deleteAccount':
      return 'confirmdeleteAccount';
    case 'remove':
      return 'removeProduct';
    case 'cancel':
      return 'cancelProduct';
    case 'address':
      return 'deleteAddress';
    default:
      return 'clearBagconfrim';
    }
  }

  private getConfirmButtonText(type: string): string {
    switch (type) {
    case 'logout':
      return 'logout';
    case 'deleteAccount':
      return 'Yes';
    case 'remove':
      return 'Remove';
    case 'cancel':
      return 'Yes';
    case 'address':
      return 'Delete';
    default:
      return 'clear';
    }
  }
}
